// extracted by mini-css-extract-plugin
export default {"contact-form":"Form_contact-form__SDAkd","error-message":"Form_error-message__FSu7l","sent-message":"Form_sent-message__H5ZAH"};